import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '@/redux/store'

interface GlobalSearchState {
  isShowing: boolean
  searchTerm: string
}

const INITIAL_STATE: GlobalSearchState = {
  isShowing: false,
  searchTerm: '',
}

const globalSearch = createSlice({
  name: 'globalSearch',
  initialState: INITIAL_STATE,
  reducers: {
    setIsShowing: (
      state,
      action: PayloadAction<GlobalSearchState['isShowing']>,
    ) => {
      state.isShowing = action.payload
    },
    setSearchTerm: (
      state,
      action: PayloadAction<GlobalSearchState['searchTerm']>,
    ) => {
      state.searchTerm = action.payload
    },
  },
})

export const selectGlobalSearch = (state: RootState) => state.globalSearch

export const selectIsShowing = createSelector(
  selectGlobalSearch,
  (state) => state.isShowing,
)

export const selectSearchTerm = createSelector(
  selectGlobalSearch,
  (state) => state.searchTerm,
)

export const { setIsShowing, setSearchTerm } = globalSearch.actions

export const globalSearchReducer = globalSearch.reducer
